
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/webinars/watch/[videoId]",
      function () {
        return require("private-next-pages/webinars/watch/[videoId].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/webinars/watch/[videoId]"])
      });
    }
  